import { render, staticRenderFns } from "./DeviceMonitorTemplateItemUpdateBox.vue?vue&type=template&id=92f77180"
import script from "./DeviceMonitorTemplateItemUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceMonitorTemplateItemUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports